import { ConditionalEdge } from './conditional-edge'

// Declared at module scope to avoid React Flow Pitfall 2:
// edgeTypes must not be recreated on every render.
export const edgeTypes = {
  conditional: ConditionalEdge,
}

// Default edge type — all edges use the conditional renderer.
export const defaultEdgeType = 'conditional' as const
